module.exports = __webpack_public_path__ + "3c5f6253b6c7b11c97fc572d171780e8.png";